<div class="container default-container popup-content">
    <div class="popup-header row">
        <h2 class="col h-small">
            {{ 'product.review.lbl.001' | translate }}
        </h2>
        <a
            href="javascript:;"
            class="col-auto close-popup-btn"
            (click)="onClickClosePopup()"
        >
            <svg width="22" height="22" viewBox="0 0 22 22">
                <path d="M1 1L21 21" />
                <path d="M21 1L1 21" />
            </svg>
        </a>
    </div>

    <div class="popup-body results searching-result row">
        <div class="col-12">
            <!-- Upload Image -->
            <div class="review-pd bg-light rounded p-3 p-lg-5 row mb-3">
                <ng-container *ngIf="filePath === ''; then img1; else img2">
                </ng-container>
                <input
                    type="file"
                    style="display: none"
                    id="fileUpload"
                    name="fileData"
                    (change)="onChangeFileSelected($event)"
                    #fileUpload
                />
                <!-- <button
                    type="button"
                    id="saveImg"
                    (click)="fileUpload.click()"
                    class="border-0"
                >
                    <svg
                        width="128"
                        height="128"
                        viewBox="0 0 458 458"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M129.606 1.541C49.7332 10.314 10.1213 50.343 1.56825 130.927C-0.52275 150.629 -0.52275 307.371 1.56825 327.073C10.0272 406.774 47.6192 445.584 126.606 456.161C140.89 458.074 319.427 458.105 332.606 456.197C372.463 450.426 398.957 439.037 418.865 419.114C438.66 399.304 449.437 374.924 455.825 335.5C457.18 327.141 457.51 313.783 457.836 254.104C458.13 200.403 457.932 181.995 457.037 179.833C454.31 173.249 445.375 169.043 438.214 170.971C435.085 171.813 429.945 176.041 426.929 180.253C426.832 180.389 426.494 192.511 426.179 207.191L425.606 233.882L419.106 228.464C403.376 215.355 383.194 210.294 363.803 214.597C348.711 217.946 346.464 219.552 294.606 264.056C261.559 292.416 244.945 306.023 241.273 307.735C237.143 309.662 234.325 310.22 228.773 310.213C219.388 310.202 214.639 308.204 205.2 300.296C195.574 292.232 191.281 289.716 181.598 286.465C166.841 281.512 149.672 282.237 135.73 288.403C132.611 289.782 109.574 304.67 84.5372 321.486C59.5002 338.303 38.6332 351.826 38.1652 351.537C37.1012 350.879 34.5163 336.589 33.1463 323.789C32.5103 317.853 32.1063 280.93 32.1063 228.783C32.1063 138.398 32.5133 128.585 37.0493 109.516C46.4183 70.133 68.0222 47.692 106.02 37.874C124.921 32.991 129.33 32.699 193.606 32.084C252.789 31.517 254.71 31.439 258.103 29.446C263.902 26.039 266.351 21.477 265.894 14.935C265.436 8.379 262.755 4.01 257.725 1.623C254.685 0.180999 248.023 0.0120001 197.955 0.111C158.761 0.189 137.953 0.624 129.606 1.541ZM349.588 1.75C347.945 2.712 336.183 14.075 323.451 27C298.716 52.109 297.406 53.963 299.1 61.473C300.82 69.099 306.557 73.99 313.791 73.996C320.3 74.002 322.797 72.555 332.275 63.279L341.106 54.638V100.503C341.106 144.849 341.175 146.51 343.177 150.647C348.853 162.372 365.359 162.372 371.035 150.647C373.037 146.51 373.106 144.849 373.106 100.503V54.638L381.937 63.279C391.415 72.555 393.912 74.002 400.421 73.996C407.655 73.99 413.392 69.099 415.112 61.473C416.806 53.963 415.496 52.109 390.761 27C378.029 14.075 366.267 2.712 364.624 1.75C362.969 0.78 359.617 0 357.106 0C354.595 0 351.243 0.78 349.588 1.75ZM152.423 86.436C125.775 92.518 106.954 115.822 106.739 143C106.609 159.409 112.136 173.034 123.592 184.55C146.968 208.048 183.244 208.048 206.62 184.55C218.076 173.034 223.603 159.409 223.473 143C223.32 123.626 213.747 105.924 197.571 95.105C193.417 92.326 187 89.109 183.312 87.956C174.654 85.247 160.649 84.558 152.423 86.436ZM156.824 118.376C147.406 121.888 141.056 129.109 139.1 138.529C136.659 150.287 142.42 161.988 153.326 167.422C164.342 172.912 178.509 169.738 185.829 160.141C196.301 146.411 192.083 127.641 176.77 119.829C171.572 117.177 161.922 116.474 156.824 118.376ZM367.865 246.423C365.808 247.157 362.883 248.563 361.365 249.547C359.848 250.531 337.57 269.373 311.86 291.418C262.586 333.668 257.764 337.189 244.606 340.527C241.306 341.364 234.257 342.06 228.941 342.074C212.084 342.117 200.009 337.655 186.606 326.429C175.562 317.18 171.679 315.519 161.106 315.523C153.943 315.525 151.889 315.917 148.046 318.013C144.704 319.835 53.8452 380.468 51.2102 382.634C50.3482 383.342 56.1563 390.831 62.2143 396.821C73.5303 408.01 88.3503 415.707 107.904 420.549C127.37 425.369 130.604 425.5 230.106 425.5C315.015 425.5 324.641 425.336 334.871 423.713C389.26 415.087 414.864 389.527 423.738 335C424.677 329.232 425.482 315.875 425.787 301L426.291 276.5L410.073 262.775C398.202 252.728 392.404 248.507 388.443 247.025C382.21 244.693 373.432 244.436 367.865 246.423Z"
                            fill="black"
                        />
                    </svg>

                    <span class="visually-hidden">{{
                        'product.review.lbl.019' | translate
                    }}</span>
                </button> -->
                <ng-container *ngIf="filePath !== null && filePath !== ''">
                    <!-- <button type="button" (click)="clearFile()">
                        <svg
                            width="18"
                            height="20"
                            viewBox="0 0 18 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11 8V15M7 8V15M3 4V15.8C3 16.9201 3 17.4798 3.21799 17.9076C3.40973 18.2839 3.71547 18.5905 4.0918 18.7822C4.5192 19 5.07899 19 6.19691 19H11.8031C12.921 19 13.48 19 13.9074 18.7822C14.2837 18.5905 14.5905 18.2839 14.7822 17.9076C15 17.4802 15 16.921 15 15.8031V4M3 4H5M3 4H1M5 4H13M5 4C5 3.06812 5 2.60241 5.15224 2.23486C5.35523 1.74481 5.74432 1.35523 6.23438 1.15224C6.60192 1 7.06812 1 8 1H10C10.9319 1 11.3978 1 11.7654 1.15224C12.2554 1.35523 12.6447 1.74481 12.8477 2.23486C12.9999 2.6024 13 3.06812 13 4M13 4H15M15 4H17"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>

                        <span>{{ 'product.review.lbl.021' | translate }}</span>
                    </button> -->
                </ng-container>
            </div>

            <!-- Rating -->
            <div class="review-pd review-starr row mx-3 mb-3">
                <div class="col-12 border d-flex p-3">
                    <span class="w-auto me-3">{{
                        'product.review.lbl.020' | translate
                    }}</span>
                    <div
                        class="starrr bdl_ddd d-flex align-items-center w-auto"
                        id="star"
                    >
                        <span class="your-choice-was" style="display: none">
                            <span style="display: none" class="choice"></span>
                        </span>
                        <a
                            href="javascript:;"
                            class="fa fa-star-o faPopup"
                            id="faPopup1"
                            (click)="onClickSetGrade(1)"
                        ></a>
                        <a
                            href="javascript:;"
                            class="fa fa-star-o faPopup"
                            id="faPopup2"
                            (click)="onClickSetGrade(2)"
                        ></a>
                        <a
                            href="javascript:;"
                            class="fa fa-star-o faPopup"
                            id="faPopup3"
                            (click)="onClickSetGrade(3)"
                        ></a>
                        <a
                            href="javascript:;"
                            class="fa fa-star-o faPopup"
                            id="faPopup4"
                            (click)="onClickSetGrade(4)"
                        ></a>
                        <a
                            href="javascript:;"
                            class="fa fa-star-o faPopup"
                            id="faPopup5"
                            (click)="onClickSetGrade(5)"
                        ></a>
                    </div>
                </div>
            </div>

            <!-- Review field -->
            <div class="row info-row editor mb-5 px-lg-3">
                <div class="col-12">
                    <textarea
                        name="contents"
                        value=""
                        id="contentsNew"
                    ></textarea>
                </div>
            </div>

            <!-- Submit button -->
            <div class="row d-flex justify-content-center mb-5">
                <div class="d-grid gap-2 col-lg-auto mx-auto">
                    <button
                        type="button"
                        id="writeBtn"
                        class="btn btn-outline-primary btn-lg mx-3"
                        (click)="onSubmitSaveReview()"
                    >
                        {{ 'product.review.lbl.004' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Template -->
<ng-template #img1>
    <!-- <img src="./assets/img/noImage.jpg" alt="" class="userPhoto" /> -->
    <button
        type="button"
        id="saveImg"
        (click)="fileUpload.click()"
        class="border-0 d-flex flex-column w-100 bg-transparent align-items-center py-3"
    >
        <svg
            width="100"
            height="100"
            viewBox="0 0 20 20"
            fill="none"
            class="mb-3"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19 8.2002L19 16.0001M9.7998 1H4.1998C3.0797 1 2.51994 1 2.09212 1.21799C1.71579 1.40973 1.40952 1.71547 1.21777 2.0918C1 2.5192 1 3.07899 1 4.19691V15.8031C1 16.2881 1 16.6679 1.01778 16.9774M19 16.0001C18.9992 16.9884 18.9866 17.5058 18.782 17.9074C18.5903 18.2837 18.2845 18.5905 17.9082 18.7822C17.4808 19 16.921 19 15.8031 19H4.19642C3.07851 19 2.51952 19 2.09212 18.7822C1.71579 18.5905 1.40952 18.2837 1.21777 17.9074C1.09448 17.6654 1.04099 17.3813 1.01778 16.9774M19 16.0001L14.232 10.4375L14.2306 10.436C13.8077 9.9426 13.5959 9.69551 13.3447 9.60645C13.1241 9.52821 12.8831 9.53004 12.6636 9.61133C12.4134 9.70397 12.2049 9.95387 11.7881 10.4541L9.11692 13.6595C8.73105 14.1226 8.53699 14.3554 8.30138 14.4489C8.09354 14.5313 7.86435 14.5406 7.6499 14.4773C7.4058 14.4053 7.19093 14.1904 6.76123 13.7607L6.26416 13.2637C5.82667 12.8262 5.60792 12.6076 5.36032 12.5361C5.14286 12.4734 4.91037 12.4869 4.70117 12.5732C4.46298 12.6716 4.26981 12.9124 3.8833 13.3955L1.01778 16.9774M1.01778 16.9774L1.00002 16.9996M16 7V1M16 1L13 3M16 1L19 3M7 7C7.55228 7 8 6.55228 8 6C8 5.44772 7.55228 5 7 5C6.44772 5 6 5.44772 6 6C6 6.55228 6.44772 7 7 7Z"
                stroke="black"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <span>{{ 'product.review.lbl.019' | translate }}</span>
    </button>
</ng-template>

<ng-template #img2>
    <div id="saveImg" (click)="fileUpload.click()" class="mb-3">
        <img src="{{ filePath }}" alt="" class="userPhoto img-fluid" />
    </div>
    <div class="d-flex align-items-center gap-2 justify-content-center">
        <button
            type="button"
            id="saveImg"
            (click)="fileUpload.click()"
            class="btn btn-outline-secondary"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19 8.2002L19 16.0001M9.7998 1H4.1998C3.0797 1 2.51994 1 2.09212 1.21799C1.71579 1.40973 1.40952 1.71547 1.21777 2.0918C1 2.5192 1 3.07899 1 4.19691V15.8031C1 16.2881 1 16.6679 1.01778 16.9774M19 16.0001C18.9992 16.9884 18.9866 17.5058 18.782 17.9074C18.5903 18.2837 18.2845 18.5905 17.9082 18.7822C17.4808 19 16.921 19 15.8031 19H4.19642C3.07851 19 2.51952 19 2.09212 18.7822C1.71579 18.5905 1.40952 18.2837 1.21777 17.9074C1.09448 17.6654 1.04099 17.3813 1.01778 16.9774M19 16.0001L14.232 10.4375L14.2306 10.436C13.8077 9.9426 13.5959 9.69551 13.3447 9.60645C13.1241 9.52821 12.8831 9.53004 12.6636 9.61133C12.4134 9.70397 12.2049 9.95387 11.7881 10.4541L9.11692 13.6595C8.73105 14.1226 8.53699 14.3554 8.30138 14.4489C8.09354 14.5313 7.86435 14.5406 7.6499 14.4773C7.4058 14.4053 7.19093 14.1904 6.76123 13.7607L6.26416 13.2637C5.82667 12.8262 5.60792 12.6076 5.36032 12.5361C5.14286 12.4734 4.91037 12.4869 4.70117 12.5732C4.46298 12.6716 4.26981 12.9124 3.8833 13.3955L1.01778 16.9774M1.01778 16.9774L1.00002 16.9996M16 7V1M16 1L13 3M16 1L19 3M7 7C7.55228 7 8 6.55228 8 6C8 5.44772 7.55228 5 7 5C6.44772 5 6 5.44772 6 6C6 6.55228 6.44772 7 7 7Z"
                    stroke="black"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>

            <span class="visually-hidden">{{
                'product.review.lbl.019' | translate
            }}</span>
        </button>
        <button
            type="button"
            (click)="clearFile()"
            class="btn btn-outline-secondary"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 18 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11 8V15M7 8V15M3 4V15.8C3 16.9201 3 17.4798 3.21799 17.9076C3.40973 18.2839 3.71547 18.5905 4.0918 18.7822C4.5192 19 5.07899 19 6.19691 19H11.8031C12.921 19 13.48 19 13.9074 18.7822C14.2837 18.5905 14.5905 18.2839 14.7822 17.9076C15 17.4802 15 16.921 15 15.8031V4M3 4H5M3 4H1M5 4H13M5 4C5 3.06812 5 2.60241 5.15224 2.23486C5.35523 1.74481 5.74432 1.35523 6.23438 1.15224C6.60192 1 7.06812 1 8 1H10C10.9319 1 11.3978 1 11.7654 1.15224C12.2554 1.35523 12.6447 1.74481 12.8477 2.23486C12.9999 2.6024 13 3.06812 13 4M13 4H15M15 4H17"
                    stroke="black"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>

            <span class="visually-hidden">{{
                'product.review.lbl.021' | translate
            }}</span>
        </button>
    </div>
</ng-template>
